import { DropdownMenu, IconButton, TimeClockIcon, Tooltip } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { useTrackScheduleFeaturesInteraction } from '@spa/core/externals/segment'
import { useMemoSelector } from '@spa/redux/hooks'
import { entitiesActions } from '@spa/scenes/Plannings/redux/modules/entities'
import { COUNTERS_MODE } from '@spa/scenes/Plannings/redux/reducers/settings/settings'
import { getSettings } from '@spa/scenes/Plannings/redux/selectors'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

const CountersDropdownContainer = () => {
  const { t } = usePlanningTranslation()
  const scheduleTracker = useTrackScheduleFeaturesInteraction()
  const { countersMode } = useMemoSelector(getSettings)
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const searchParamsObj = Object.fromEntries(searchParams)

  /**
   *
   */
  const getIdFromParams = (params: string | undefined) => {
    const paramAsNumber = Number(params)
    return paramAsNumber > 0 ? paramAsNumber : undefined
  }

  const handleChangeCounterMode = newCountersMode => {
    if (newCountersMode !== countersMode) {
      const teamId = getIdFromParams(searchParamsObj.team)
      const locationId = getIdFromParams(searchParamsObj.location)
      dispatch(
        entitiesActions.fetchAndHydrateAllContractCounters({
          countersMode: newCountersMode,
          teamId,
          locationId
        })
      )
    }
  }

  return (
    <DropdownMenu
      dropdownPosition='bottom-start'
      dropdownWidth='xl'
      onOpen={scheduleTracker.countersParametersMenuOpened}
    >
      <DropdownMenu.Target>
        <Tooltip label={t('weekly.header.changeCountersDisplay')}>
          <IconButton
            variant='tertiary'
            intent='neutral-dark'
            size='s'
            icon={<TimeClockIcon />}
          />
        </Tooltip>
      </DropdownMenu.Target>

      <DropdownMenu.Dropdown>
        <DropdownMenu.Group label={t('weekly.header.counterType')}>
          <DropdownMenu.Option
            onClick={() => handleChangeCounterMode(COUNTERS_MODE.planned)}
            active={countersMode === COUNTERS_MODE.planned}
            selected={countersMode === COUNTERS_MODE.planned}
          >
            {t('weekly.header.plannedCounters')}
          </DropdownMenu.Option>
          <DropdownMenu.Option
            onClick={() => handleChangeCounterMode(COUNTERS_MODE.realized)}
            active={countersMode === COUNTERS_MODE.realized}
            selected={countersMode === COUNTERS_MODE.realized}
          >
            {t('weekly.header.realCounters')}
          </DropdownMenu.Option>
          <DropdownMenu.Option
            onClick={() => handleChangeCounterMode(COUNTERS_MODE.monthly)}
            active={countersMode === COUNTERS_MODE.monthly}
            selected={countersMode === COUNTERS_MODE.monthly}
          >
            {t('weekly.header.monthlyCounters')}
          </DropdownMenu.Option>
        </DropdownMenu.Group>
      </DropdownMenu.Dropdown>
    </DropdownMenu>
  )
}

export default CountersDropdownContainer
